"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));

require("./_content-placeholder.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ContentPlaceholder() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "manage-traffic-video-placeholder"
  }, /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    primaryColor: "rgb(232, 236, 240, 0.75)",
    secondaryColor: "rgb(232, 236, 240, 0.2)",
    viewBox: "0 0 1500 1329"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "0",
    rx: "0",
    ry: "0",
    width: "911",
    height: "424"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "941",
    y: "0",
    rx: "0",
    ry: "0",
    width: "530",
    height: "311"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "941",
    y: "388",
    rx: "0",
    ry: "0",
    width: "530",
    height: "140"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "744",
    rx: "0",
    ry: "0",
    width: "1494",
    height: "140"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "7",
    y: "989",
    rx: "0",
    ry: "0",
    width: "480",
    height: "84"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "514",
    y: "991",
    rx: "0",
    ry: "0",
    width: "480",
    height: "84"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "1013",
    y: "992",
    rx: "0",
    ry: "0",
    width: "480",
    height: "84"
  })));
}

var _default = (0, _react.memo)(ContentPlaceholder);

exports.default = _default;